import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '@yalendar/shared/ui-core';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Navbar from '../Navbar';
import PlayIcon from './icons/PlayIcon';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import heroImage from '../../public/hero_image.png';
var ModalVideoSetup = dynamic(function () {
  return import('./ModalVideoSetup');
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('./ModalVideoSetup')];
    },
    modules: ["../components/HomePage/Navbar.tsx -> " + './ModalVideoSetup']
  }
});

var HomeNavbar = function HomeNavbar(_ref) {
  var appURL = _ref.appURL;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      videoOpen = _useState[0],
      setVideoOpen = _useState[1];

  var handleClick = function handleClick(e) {
    e.preventDefault();
    setVideoOpen(true);
  };

  var _useState2 = useState(false),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1]; // Top: 0 takes us all the way back to the top of the page
  // Behavior: smooth keeps it smooth!


  var scrollToTop = function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(function () {
    // Button is displayed after scrolling for 500 pixels
    var toggleVisibility = function toggleVisibility() {
      if (window.pageYOffset > 5) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return function () {
      return window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: "mb-12 gradient",
    children: [/*#__PURE__*/_jsx("div", {
      id: "header",
      className: classNames(isVisible ? 'sticky bg-white' : 'gradient', 'top-0 z-30 w-full py-4 text-black lg:py-6'),
      children: /*#__PURE__*/_jsx(Navbar, {
        appURL: appURL,
        isVisible: isVisible
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "container mx-auto mt-12",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "px-3 mx-auto text-center max-w-7xl lg:px-0",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "text-center",
          children: [/*#__PURE__*/_jsxs("h1", {
            className: "text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl md:text-6xl",
            children: [/*#__PURE__*/_jsx("span", {
              className: "block text-transparent xl:inline bg-clip-text bg-gradient-to-r from-green-400 to-indigo-800",
              children: t('landing.quickSetup')
            }), ' ', /*#__PURE__*/_jsx("span", {
              className: "block text-indigo-600 xl:inline",
              children: t('landing.onLineMetting')
            })]
          }), /*#__PURE__*/_jsx("h2", {
            "data-cy": "homePage-title",
            className: "max-w-md mx-auto mt-3 text-xl text-gray-500 sm:text-lg md:mt-5 md:text-3xl md:leading-10 md:max-w-4xl",
            children: /*#__PURE__*/_jsx(Trans, {
              t: t,
              i18nKey: 'landing.offerBestExperience',
              components: {
                boldGreen: /*#__PURE__*/_jsx("span", {
                  className: "block font-semibold text-transparent xl:inline bg-clip-text bg-gradient-to-r from-indigo-800 to-green-600"
                }),
                boldIndigo: /*#__PURE__*/_jsx("span", {
                  className: "font-bold text-indigo-500"
                })
              }
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "items-center mx-auto mt-5 sm:flex sm:justify-center md:mt-8",
          children: [/*#__PURE__*/_jsx("div", {
            className: "flex flex-col",
            children: /*#__PURE__*/_jsx(Link, {
              href: "".concat(appURL, "/auth/register"),
              children: /*#__PURE__*/_jsx("a", {
                className: "flex items-center justify-center w-full px-8 py-3 text-base font-medium text-white duration-500 rounded-md transition-backgroundImage md:py-4 md:text-lg md:px-10 bg-gradient-to-r hover:bg-gradient-to-r from-purple-600 to-indigo-500 hover:from-indigo-500 hover:to-purple-600",
                children: t('landing.startSharingYourAvailabilitiesForFree')
              })
            })
          }), /*#__PURE__*/_jsxs("button", {
            className: "inline-flex items-center px-8 py-2 my-2 ml-3 font-semibold text-gray-300 no-underline transition-colors bg-transparent border border-gray-800 rounded-md cursor-pointer hover:border-gray-100 lg:mx-0 lg:ml-2 hover:font-semibold md:my-6 lg:py-4",
            onClick: handleClick,
            children: [/*#__PURE__*/_jsx("span", {
              className: "mr-2",
              children: t('landing.discoverVideo')
            }), ' ', /*#__PURE__*/_jsx(PlayIcon, {
              fill: "white"
            })]
          })]
        }), /*#__PURE__*/_jsx(ModalVideoSetup, {
          isOpen: videoOpen,
          videoId: "Ozt-MJOK7HA",
          onClose: function onClose() {
            return setVideoOpen(false);
          }
        })]
      }), /*#__PURE__*/_jsx("section", {
        className: "relative w-full h-full max-w-xl mx-auto my-6 md:max-w-7xl lg:my-12",
        children: /*#__PURE__*/_jsx(Image, {
          src: heroImage,
          layout: "intrinsic",
          className: "-mb-16",
          objectFit: "scale-down",
          alt: "Yalendar hero image"
        })
      })]
    })]
  });
};

export default HomeNavbar;